//lander
import '../../web/assets/less/sportspage.less';
import * as App from '../../js/entrypoints/sportsbook';

App.init({ entrypoint: 'sportsv2' })
